export default __webpack_public_path__ + "static/media/logo-moment.8ba60517.svg";